/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 ..\UG.glb --transform 
Files: ..\UG.glb [1.19MB] > C:\Users\fabia\OneDrive\Dokumente\Dateien\To-Do\IDPA_BM-Campus\glb\gltfjsx\UG-transformed.glb [53.32KB] (96%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

export function UGModel(props) {
  const { nodes, materials } = useGLTF('/models/UG-transformed.glb')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.UG.geometry} material={materials.Default} position={[-10, 0, -18.5]} rotation={[Math.PI / 2, 0, 0]} scale={0.001} />
    </group>
  )
}

useGLTF.preload('/models/UG-transformed.glb')
